var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-image",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 76,
    viewBox: "0 0 87 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_580",
    "data-name": "Trazado 580",
    d: "M76.127,6.429H10.877a5.433,5.433,0,0,0-5.437,5.429V66.143a5.433,5.433,0,0,0,5.437,5.429h65.25a5.433,5.433,0,0,0,5.438-5.429V11.857A5.433,5.433,0,0,0,76.127,6.429ZM10.877,1A10.866,10.866,0,0,0,0,11.857V66.143A10.866,10.866,0,0,0,10.877,77h65.25A10.866,10.866,0,0,0,87,66.143V11.857A10.866,10.866,0,0,0,76.127,1H10.877Z",
    transform: "translate(-0.002 -1)",
    fill: "#707070",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_581",
    "data-name": "Trazado 581",
    d: "M57.324,8.351a2.923,2.923,0,0,1,3.369-.542l22.053,11.35V45.39H1V33.732l15.45-13.722a2.923,2.923,0,0,1,3.678-.361L35.662,29.983,57.324,8.357Z",
    transform: "translate(1.626 26.484)",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_582",
    "data-name": "Trazado 582",
    d: "M11.158,20.286A8.143,8.143,0,1,0,3,12.143a8.15,8.15,0,0,0,8.156,8.143Z",
    transform: "translate(13.31 12.286)",
    fill: "#707070",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.593b6c328c96ba866d9cc460957ff514.svg";
export { ForwardRef as ReactComponent };